export const XMAS_PROMOTION_CONFIG = {
  menuSkus: [
    'V1961',
    'V1968',
    'V1975',
    'V8294',
    'V8296',
    'V8298',
    'V10487',
    'V1960',
    'V1967',
    'V1974',
    'V10489',
    'V10490',
    'V10491',
    'V1959',
    'V1966',
    'V1973',
    'V10495',
    'V10497',
    'V9309',
    'V10499',
    'V10500',
    'V10501',
    'V8306',
    'V10511',
    'V10513',
    'V10515',
    'V10517',
    'V10519',
    'V10521',
    'V10523',
    'V10525',
    'V10527',
    'V10529',
    'V10531',
    'V10533',
    'V10535'
  ],
  giftSkusMap: {
    quantity: ['V10505'], // que cắm
    value: ['V2005'] // thiệp
  },
  timeframe: {
    start: new Date('2025-12-15T00:00:00+07:00'),
    end: new Date('2025-12-26T00:00:00+07:00')
  },
  saleProgram: {
    byQuantity: 'Tặng que cắm Giáng sinh',
    byValue: 'Tặng thiệp Giáng sinh'
  }
}
